import { render, staticRenderFns } from "./MenelausTheoremViz.vue?vue&type=template&id=01fe4b50&scoped=true"
import script from "./MenelausTheoremViz.vue?vue&type=script&lang=js"
export * from "./MenelausTheoremViz.vue?vue&type=script&lang=js"
import style0 from "./MenelausTheoremViz.vue?vue&type=style&index=0&id=01fe4b50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe4b50",
  null
  
)

export default component.exports